<template>
<div class="row justify-center container">
  <q-page :class="pageClass">
    <q-card
      class="q-pa-md"
      active-color="primary"
      indicator-color="primary"
      align="justify"
    >
      <q-card-section v-if="loading"><q-spinner/></q-card-section>
      <q-card-section v-else-if="result">
        <div v-if="title" class="text-h5 q-pb-sm">{{ title }}</div>
        <div v-if="description" class="description text-subtitle2">{{ description }}</div>

        <overview-info :catalog="catalog" :downloads="downloads" :keywords="keywords" :legend="legend" />
        <metadata-info :metadata="metadata" :layerDescriptor="layerDescriptor" />
      </q-card-section>
      <q-card-section v-else>
        <div class="panel-subtitle">{{ $t('messages.referenceNotFound') }}: {{ giscube_id }}</div>
      </q-card-section>
    </q-card>
  </q-page>
</div>
</template>

<script>
import { QCard, QCardSection, QPage, QSpinner } from 'quasar'
import axios from 'axios'

import OverviewInfo from 'components/LayerInfo/OverviewInfo.vue'
import MetadataInfo from 'components/LayerInfo/MetadataInfo.vue'

export default {
  name: 'PageIndex',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.giscube_id = to.params.q
      vm.getResult()
    })
  },
  beforeRouteUpdate (to, from, next) {
    let vm = this
    vm.giscube_id = to.params.q
    vm.getResult()
    next()
  },
  components: {
    OverviewInfo,
    MetadataInfo,
    QCard,
    QCardSection,
    QPage,
    QSpinner
  },
  data () {
    return {
      giscube_id: '',
      loading: false,
      result: null,
      tab: 'info'
    }
  },
  computed: {
    catalog () {
      return this.result && this.result.catalog
    },
    downloads () {
      return this.result && this.result.children && this.result.children.length > 0 && this.result.children.filter(child => child.giscube && child.giscube.downloadable)
    },
    description () {
      return this.result && this.result.description
    },
    keywords () {
      return this.result && this.result.keywords && this.result.keywords.split(',')
    },
    layerDescriptor () {
      const layerDescriptor = this.result && this.result.children && this.result.children.length > 0 && this.result.children[0]
      let url = layerDescriptor && layerDescriptor.url
      const type = layerDescriptor && layerDescriptor.type
      if (type !== 'document') {
        const text = url
        const projection = layerDescriptor.projection
        if (type && type.toLowerCase() === 'wms') {
          url += '?service=WMS&request=GetCapabilities'
        }
        return {
          projection: projection,
          name: 'URL',
          text: text,
          href: url,
          type: type
        }
      }

      return null
    },
    legend () {
      return this.result && this.result.legend
    },
    metadata () {
      if (!this.result) {
        return null
      }
      for (const property in this.result.metadata) {
        if (this.result.metadata[property]) {
          return this.result.metadata
        }
      }
      return null
    },
    title () {
      return this.result && this.result.title
    },
    url () {
      return this.$config.catalog.base + 'geoportal/giscube_id/' + this.giscube_id
    },

    pageClass () {
      return this.$q.platform.is.mobile ? 'q-pa-md' : 'q-py-md col-10 col-md-6'
    }
  },
  methods: {
    getResult () {
      this.loading = true
      const headers = this.$store.getters['auth/headers']
      const conf = {
        headers
      }
      axios.get(this.url, conf).then(response => {
        this.result = response && response.data && response.data.results.length > 0 && response.data.results[0]
        this.loading = false
      }).catch(error => {
        console.log(error)
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  background-color: $grey-1;
}
</style>
